import { useQueryParams } from 'hooks';
import { DateTime } from 'luxon';
import { parse } from 'query-string';
import { useMemo } from 'react';
import { QueryParam } from 'utils/constants/queryParam';
import { getQueryParam } from 'utils/queryStringUtils';
import { SchedulingType as SchedulingCalendarType } from '../types/types';
import { getSchedulingTimeRangeFromParamString } from '../utils/utils';
import useCalendarView from './useCalendarView';

export type SchedulingQueryParams = ReturnType<typeof useSchedulingQueryParams>;

export default function useSchedulingQueryParams() {
  const queryParams = useQueryParams();

  const memberId = queryParams.getParam(QueryParam.EMPLOYEE_ID);
  const memberGroupId = queryParams.getParam(QueryParam.EMPLOYEE_GROUP_ID);
  const positionId = queryParams.getParam(QueryParam.POSITION_ID);
  const projectId = queryParams.getParam(QueryParam.PROJECT_ID);
  const projectGroupId = queryParams.getParam(QueryParam.PROJECT_GROUP_ID);
  const costCodeId = queryParams.getParam(QueryParam.COST_CODE_ID);
  const costCodeGroupId = queryParams.getParam(QueryParam.COST_CODE_GROUP_ID);
  const equipmentId = queryParams.getParam(QueryParam.EQUIPMENT_ID);
  const equipmentCategoryId = queryParams.getParam(QueryParam.EQUIPMENT_CATEGORY_ID);
  const colors = queryParams.getParam(QueryParam.COLORS);
  const type = queryParams.getParam(QueryParam.TYPE) as SchedulingCalendarType | null;
  const stringTime = getQueryParam(parse(location.search), QueryParam.TIME, DateTime.local().toFormat('M-d-yyyy'));
  const currentView = useCalendarView();

  return useMemo(() => {
    const colorList: string[] | null = colors ? colors.split(',') : null;

    return {
      memberId,
      memberGroupId,
      positionId,
      projectId,
      projectGroupId,
      costCodeId,
      costCodeGroupId,
      equipmentId,
      equipmentCategoryId,
      colors: colorList,
      timeRange: getSchedulingTimeRangeFromParamString(stringTime, currentView),
      type,
    };
  }, [
    colors,
    costCodeGroupId,
    costCodeId,
    currentView,
    equipmentCategoryId,
    equipmentId,
    memberGroupId,
    memberId,
    positionId,
    projectGroupId,
    projectId,
    stringTime,
    type,
  ]);
}
